module.exports = __webpack_public_path__ + "img/character_l.93f37bda.svg";